<script setup lang="ts"></script>

<template>
  <div class="layout min-h-dvh bg-background text-foreground">
    <slot />
  </div>
</template>
